const RESERVED_TENANT_LABELS = [
  "www",
  "portal",
  "admin",
  "reseller",
  "api",
];

const getBaseDomain = () =>
  (process.env.REACT_APP_TENANT_BASE_DOMAIN || "")
    .trim()
    .toLowerCase()
    .replace(/^\.+|\.+$/g, "");

export const getTenantSlug = () => {
  const baseDomain = getBaseDomain();

  if (!baseDomain || typeof window === "undefined") return null;

  const hostname = window.location.hostname.toLowerCase().replace(/\.$/, "");
  const domainSuffix = `.${baseDomain}`;

  if (!hostname.endsWith(domainSuffix)) return null;

  const slug = hostname.slice(0, -domainSuffix.length);

  if (!slug || slug.includes(".") || RESERVED_TENANT_LABELS.includes(slug)) {
    return null;
  }

  return slug;
};

export const isTenantHost = () => getTenantSlug() !== null;
